import ProcessingModeControl from './ProcessingModeControl';
import { isDesktop } from '@/lib/fileSystem';
import { useLocation } from 'react-router-dom';
import { FileText, Pencil, Layers, Scissors, ScanText, ArrowLeftRight, ChevronDown } from 'lucide-react';
import { useDocumentWorkspace, useWorkspaceNavigate } from '@/contexts/DocumentWorkspace';

const tools = [
  ['/viewer', 'Edit document', Pencil], ['/merge', 'Add / merge files', Layers],
  ['/viewer?panel=pages', 'Organize pages', Scissors], ['/ocr', 'Recognize text', ScanText],
  ['/convert?tab=from-pdf', 'Convert', ArrowLeftRight],
];

export default function DocumentToolNav() {
  const workspace = useDocumentWorkspace();
  const navigate = useWorkspaceNavigate();
  const location = useLocation();
  const desktop = isDesktop();
  if (!workspace?.document && !desktop) return null;
  return <nav aria-label="Document tools" className="bg-white border-b border-gray-200 shrink-0 px-4 py-2">
    <div className="flex flex-wrap items-center gap-1.5">
      {workspace?.document && location.pathname !== '/viewer' && <button onClick={() => navigate('/viewer')} className="flex items-center gap-2 mr-3 text-sm font-medium text-gray-700 max-w-[240px]" title="Return to your document"><FileText size={17} className="shrink-0 text-brand-blue" /><span className="truncate">{workspace.document.file.name}</span></button>}
      {workspace?.document && tools.map(([path, label, Icon]) => <button key={path} disabled={workspace.busy} onClick={() => navigate(path)} aria-current={location.pathname + location.search === path ? 'page' : undefined} className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm whitespace-nowrap disabled:opacity-50 ${location.pathname + location.search === path ? 'bg-brand-light text-brand-blue font-semibold' : 'text-gray-600 hover:bg-gray-100'}`}><Icon size={16} />{label}</button>)}
      {workspace?.document && <label className="relative flex items-center text-sm text-gray-600">
        <span className="sr-only">More document tools</span>
        <select aria-label="More document tools" value="" disabled={workspace.busy} onChange={(e) => { if (e.target.value) navigate(e.target.value); }} className="bg-transparent appearance-none pl-3 pr-7 py-2 rounded-lg hover:bg-gray-100 cursor-pointer">
          <option value="">More tools</option>
          <option value="/delete">Delete pages</option><option value="/rotate">Rotate pages</option>
          <option value="/compress">Compress</option><option value="/watermark">Watermark</option>
          <option value="/page-numbers">Page numbers</option><option value="/crop">Crop pages</option>
          <option value="/protect">Password protection</option><option value="/redact">Redact</option>
          <option value="/flatten">Flatten</option>
        </select><ChevronDown size={14} className="absolute right-2 pointer-events-none" />
      </label>}
      {!desktop && <span className="text-xs text-gray-400 ml-auto">One document · edits travel with you</span>}
      {desktop && <ProcessingModeControl />}
    </div>
  </nav>;
}
